import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type WorkerEventViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  queueNameValue?: { displayId: string; id: string } | null;
  queueName: string;
  jobTypeValue?: { displayId: string; id: string } | null;
  jobType: string;
  statusValue?: { displayId: string; id: string } | null;
  status: string;
  enqueuedAtValue?: { displayId: string; id: string } | null;
  enqueuedAt: Date | null;
  startedAtValue?: { displayId: string; id: string } | null;
  startedAt: Date | null;
  completedAtValue?: { displayId: string; id: string } | null;
  completedAt: Date | null;
  payloadValue?: { displayId: string; id: string } | null;
  payload: string;
  resultValue?: { displayId: string; id: string } | null;
  result: string;
  errorValue?: { displayId: string; id: string } | null;
  error: string;
  retryCountValue?: { displayId: string; id: string } | null;
  retryCount: number;
  manualRetryCountValue?: { displayId: string; id: string } | null;
  manualRetryCount: number;
  nextRetryAtValue?: { displayId: string; id: string } | null;
  nextRetryAt: Date | null;
  durationValue?: { displayId: string; id: string } | null;
  duration: number | undefined;
  correlationIdValue?: { displayId: string; id: string } | null;
  correlationId: string;
  triggerUserIdValue: { displayId: string; id: string } | null;
};

export const WorkerEventViewForm: React.FC<WorkerEventViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    queueName = "",
    jobType = "",
    status = "",
    enqueuedAt = null,
    startedAt = null,
    completedAt = null,
    payload = "{}",
    result = "{}",
    error = "{}",
    retryCount = 0,
    manualRetryCount = 0,
    nextRetryAt = null,
    duration = 0,
    correlationId = "",
    triggerUserIdValue,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupWorkerEventLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={queueName}
                label={langStore.WorkerEventQueueNameLabel}
              />
              <ShowMultiLine
                value={jobType}
                label={langStore.WorkerEventJobTypeLabel}
              />
              <ShowMultiLine
                value={status}
                label={langStore.WorkerEventStatusLabel}
              />
              <ShowDateTime
                value={enqueuedAt}
                label={langStore.WorkerEventEnqueuedAtLabel}
              />
              <ShowDateTime
                value={startedAt}
                label={langStore.WorkerEventStartedAtLabel}
              />
              <ShowDateTime
                value={completedAt}
                label={langStore.WorkerEventCompletedAtLabel}
              />
              <InputCodeEditor
                value={payload}
                onChange={() => {}}
                label={langStore.WorkerEventPayloadLabel}
                language="json"
                readOnly={true}
              />
              <InputCodeEditor
                value={result}
                onChange={() => {}}
                label={langStore.WorkerEventResultLabel}
                language="json"
                readOnly={true}
              />
              <InputCodeEditor
                value={error}
                onChange={() => {}}
                label={langStore.WorkerEventErrorLabel}
                language="json"
                readOnly={true}
              />
              <ShowNumber
                value={retryCount}
                label={langStore.WorkerEventRetryCountLabel}
              />
              <ShowNumber
                value={manualRetryCount}
                label={langStore.WorkerEventManualRetryCountLabel}
              />
              <ShowDateTime
                value={nextRetryAt}
                label={langStore.WorkerEventNextRetryAtLabel}
              />
              <ShowNumber
                value={duration}
                label={langStore.WorkerEventDurationLabel}
              />
              <ShowMultiLine
                value={correlationId}
                label={langStore.WorkerEventCorrelationIdLabel}
              />
              <ShowReference
                label={langStore.WorkerEventTriggerUserIdLabel}
                selectedValue={langStore.displayIdByLang(
                  triggerUserIdValue?.displayId
                )}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
